declare var MAPS_PATH: string;

import getSource from '../maps/getSource';
import renderGeoJson, { focusOnPoint } from './mapOverlay/renderGeoJson';
import loadScript from '../helpers/loadScript';
import dataLayerHelper from '../helpers/dataLayerHelper';

let loadedAssets = false;
let loadedMap = false;

const $body = $('body');
const $trigger = $('.js-map-trigger');
const $modal = $('.js-map-overlay');
const $toolbar = $('.js-map-overlay-toolbar');
const $assets = $('#map-overlay-assets');

const mapOverlay = {
  initialize() {
    if (!$trigger.length) {
      return;
    }

    if (!$modal.length) {
      throw new Error('A modal for the map overlay couldn\'t been found');
    }

    if (!$assets.length) {
      throw new Error('Required assets for the map overlay aren\'t available');
    }

    if (window.location.hash === '#map') {
      this.loadMapsScript()
        .then(() => {
          this.openModal();
        });
    }

    $trigger.on('click', (e) => {
      e.preventDefault();
      this.loadMapsScript()
        .then(() => {
          this.openModal();
        });
    });

    $modal.on('click', '.js-map-overlay-close', () => {
      this.closeModal();
    });

    $toolbar.on('click', '.map-overlay__place-btn', (e) => {
      this.choosePlace(e.currentTarget);
    });
  },

  loadMapsScript() {
    return new Promise((resolve) => {
      loadScript(MAPS_PATH, () => {
        resolve(null);
      });
    });
  },

  openModal() {
    dataLayerHelper.event('Map overlay', 'open', window.location.href);

    $modal.attr('aria-hidden', 'false');

    // Prevent the body from scrolling
    $body.css('overflow', 'hidden');

    if (!loadedAssets) {
      $('head').append($assets.html());
      loadedAssets = true;
    }

    if (loadedMap) {
      return;
    }

    getSource($modal.data('geojson'))
      .then((res: GeoJSON.FeatureCollection) => {
        if (this.validateData(res)) {
          renderGeoJson(res);
        }
      });

    loadedMap = true;
  },

  closeModal() {
    $modal.attr('aria-hidden', 'true');

    // Allow the body to scroll again
    $body.css('overflow', 'visible');
  },

  validateData(res: { features: {}[] }) {
    return (typeof res.features !== 'undefined' && Array.isArray(res.features));
  },

  choosePlace(clickedElement: HTMLButtonElement) {
    const id = $(clickedElement).data('id');

    $toolbar.find('.map-overlay__place-btn.is-active').removeClass('is-active');
    $(clickedElement).addClass('is-active');

    focusOnPoint(id);
  },
};

export default mapOverlay;
